import React from 'react'
import { ViewReportList, transferColumnDefinition } from 'pages/reports'
import {
  useGetMovementsReportQuery,
  useLazyGetMovementsReportQuery,
} from 'features'
import { ErrorBoundary, DateRangePicker } from 'components'
import { format } from 'date-fns'
import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import { dniFormatter } from 'formatters'
import { LazyReportExport } from '../LazyReportExport'

export function TransfersReport({ embedded = null }) {
  const { dni = null } = useParams()

  /**
   * Holds the value of the selected date range for the listview component query builder
   */
  const [customFilterParams, setCustomFilterParams] = React.useState({
    fromdate: null,
    state: 'p,s,c',
    todate: format(new Date(), 'MM-dd-yyyy'),
  })
  /**
   * update the custom filter params when the date range picker changes
   * @param {string} name
   * @param {date} value
   */
  function handleDateRangeChange(name, value) {
    setCustomFilterParams({
      ...customFilterParams,
      [name]: format(value, 'MM-dd-yyyy'),
    })
  }
  return (
    <div>
      <ErrorBoundary fallback={<div>Error</div>}>
        <div
          className={`flex flex-row justify-between items-center ${
            !embedded ? 'mt-32' : ''
          }`}
        >
          {!embedded ? (
            <Typography variant="h2" component="p" className="text-primary">
              {dni && 'DNI: ' + dniFormatter(dni)}
            </Typography>
          ) : (
            <div></div>
          )}
          <div className="flex flex-row items-center gap-4">
            <DateRangePicker
              toDate={customFilterParams.todate}
              fromDate={customFilterParams.fromdate}
              handleFromChange={(value) =>
                handleDateRangeChange('fromdate', value)
              }
              handleToChange={(value) => handleDateRangeChange('todate', value)}
            />
            <LazyReportExport
              query={useLazyGetMovementsReportQuery}
              columns={transferColumnDefinition}
              title={`Transferencias ASL`}
              fileName={`Reporte transferencias ASL${dni && ' - DNI: ' + dni}}`}
              reportHeader={[
                ['Reporte de transferencias ASL'],
                ['Movimientos desde:', customFilterParams.fromdate],
                ['Movimientos hasta:', customFilterParams.todate],
                [""]
              ]}
              queryParams={{
                params: {
                  ...customFilterParams,
                  dni: dni,
                  movementType: 's,r,c,a,u',
                },
                paginated: false,
              }}
            />
          </div>
        </div>
        <ViewReportList
          query={useGetMovementsReportQuery}
          columnDefinition={transferColumnDefinition}
          filterCustomParams={customFilterParams}
          rowIdKey={'movementid'}
          fixedParams={{ dni: dni, movementType: 's,r,c,a,u' }}
        />
      </ErrorBoundary>
    </div>
  )
}
